'use client'

import cx from 'classnames'
import React from 'react'

import { AnimationChildrenProps } from '@/components/LandingPage/ContentModel/Animation'
import GradientTextAnimation from '@/components/LandingPage/ContentModel/Animation/GradientTextAnimation'
import { ContentModelTextType } from '@/types/ContentModel/ContentModelText'

export default function Text({
  contentModel,
  animationRef = null,
  className = '',
  style = {},
}: { contentModel: ContentModelTextType } & AnimationChildrenProps) {
  return (
    <span
      {...(contentModel.id ? { id: contentModel.id } : {})}
      className={cx(`u-font-${contentModel.fontFamily || 'yu-min'}`, className)}
      {...(animationRef != null ? { ref: animationRef } : {})}
      style={{
        ...style,
        ...(contentModel.fontSize != null ? { fontSize: contentModel.fontSize } : {}),
        ...(contentModel.color != null ? { color: contentModel.color } : {}),
        ...(contentModel.fontWeight != null ? { fontWeight: contentModel.fontWeight } : {}),
        ...(contentModel.writingMode != null ? { writingMode: contentModel.writingMode } : {}),
        ...(contentModel.verticalAlign != null ? { verticalAlign: contentModel.verticalAlign } : {}),
        ...(contentModel.lineHeight != null ? { lineHeight: contentModel.lineHeight } : {}),
        ...(contentModel.letterSpacing != null ? { letterSpacing: contentModel.letterSpacing } : {}),
        ...(contentModel.textDecoration != null ? { textDecoration: contentModel.textDecoration } : {}),
      }}
    >
      {
        // @ts-ignore
        contentModel.animation == 'gradient' ? (
          <GradientTextAnimation text={contentModel.text} random={true} />
        ) : (
          contentModel.text
        )
      }
    </span>
  )
}
